import { optionSubcategory_surfaceActions } from './surfaceActionsSubCategory.locstring.json';
import { OptionSubCategory } from 'owa-options-core';
import ComposeSurfaceActions from 'owa-surface-actions-option/lib/ComposeSurfaceActionsOption';
import ReadSurfaceActions from 'owa-surface-actions-option/lib/ReadSurfaceActionsOption';
import HoverSurfaceActions from 'owa-surface-actions-option/lib/HoverSurfaceActionsOption';

let surfaceActionsSubCategory: OptionSubCategory = {
    key: 'surfaceActions',
    titleStringKey: optionSubcategory_surfaceActions,
    options: [HoverSurfaceActions, ReadSurfaceActions, ComposeSurfaceActions],
};

export default surfaceActionsSubCategory;
